// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reviews{
    position:relative;
    height:120%;
    margin-top: -110px;
}

.reviews h1{
    font-family: 'Philosopher',serif;
    font-weight: 700;
    padding-top: 50px;

}

.reviews ::before{
        content: '';
        /* Required to display the pseudo-element */
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /* background-image: url('../Assets/Home-Page/background\\ .png'); */
        /* background-color: #E1F5FE; */
        /* Set your background image */
        background-size: cover;
        /* Ensure the image covers the entire container */
        background-position: center;
        /* Center the image */
        opacity: 0.055;
        /* Set the opacity of the background image */
        z-index: -1;
}

.review-cards ul{
    display: flex;
    justify-content: center;
   
    justify-items: center;
    align-items: center;
    align-content: center;
    list-style-type: none;
    flex-wrap: wrap;
    padding-left: 0px;
    

}



.review-card{
    display: flex;
    flex-direction: column;
    width:50vw;
    height:fit-content;
    
   justify-content: center;
   justify-items: center;
   align-items: center;
    
    
}

.review-card img{
    width: 100px;
    border-radius: 50%;
   
}

.review-card video{
    
    width:300px;
    height:200px;
    border-radius: 8px;
        /* Adds rounded corners */
        margin-bottom: 1rem;
        /* Adds space below the video */
        object-fit: cover;
        /* Ensures consistent video aspect ratio */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        /* Adds subtle shadow for depth */
        border: 2px solid #ddd;
}

.review-card h5 {
    text-align: center;
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    margin:10px;
}

.review-card p{
    text-align: center;
    width:80%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Poppins',sans-serif;
    color:#666666;
    margin:10px;
}

@media screen and (max-width:768px){
    .reviews {
            position: relative;
            height: 120%;
            margin-top: -0px;
        }
    .review-card {
            display: flex;
            flex-direction: column;
            width: 70vw;
            height: 100%;
    
            justify-content: center;
            justify-items: center;
            align-items: center;
    
    
        }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Reviews.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;QACQ,WAAW;QACX,2CAA2C;QAC3C,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,mEAAmE;QACnE,+BAA+B;QAC/B,8BAA8B;QAC9B,sBAAsB;QACtB,iDAAiD;QACjD,2BAA2B;QAC3B,qBAAqB;QACrB,cAAc;QACd,4CAA4C;QAC5C,WAAW;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;;IAEvB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;;;AAGrB;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,kBAAkB;;GAEnB,uBAAuB;GACvB,qBAAqB;GACrB,mBAAmB;;;AAGtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;QACd,yBAAyB;QACzB,mBAAmB;QACnB,+BAA+B;QAC/B,iBAAiB;QACjB,0CAA0C;QAC1C,wCAAwC;QACxC,iCAAiC;QACjC,sBAAsB;AAC9B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,aAAa;IACb,WAAW;AACf;;AAEA;IACI;YACQ,kBAAkB;YAClB,YAAY;YACZ,gBAAgB;QACpB;IACJ;YACQ,aAAa;YACb,sBAAsB;YACtB,WAAW;YACX,YAAY;;YAEZ,uBAAuB;YACvB,qBAAqB;YACrB,mBAAmB;;;QAGvB;AACR","sourcesContent":[".reviews{\n    position:relative;\n    height:120%;\n    margin-top: -110px;\n}\n\n.reviews h1{\n    font-family: 'Philosopher',serif;\n    font-weight: 700;\n    padding-top: 50px;\n\n}\n\n.reviews ::before{\n        content: '';\n        /* Required to display the pseudo-element */\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        /* background-image: url('../Assets/Home-Page/background\\ .png'); */\n        /* background-color: #E1F5FE; */\n        /* Set your background image */\n        background-size: cover;\n        /* Ensure the image covers the entire container */\n        background-position: center;\n        /* Center the image */\n        opacity: 0.055;\n        /* Set the opacity of the background image */\n        z-index: -1;\n}\n\n.review-cards ul{\n    display: flex;\n    justify-content: center;\n   \n    justify-items: center;\n    align-items: center;\n    align-content: center;\n    list-style-type: none;\n    flex-wrap: wrap;\n    padding-left: 0px;\n    \n\n}\n\n\n\n.review-card{\n    display: flex;\n    flex-direction: column;\n    width:50vw;\n    height:fit-content;\n    \n   justify-content: center;\n   justify-items: center;\n   align-items: center;\n    \n    \n}\n\n.review-card img{\n    width: 100px;\n    border-radius: 50%;\n   \n}\n\n.review-card video{\n    \n    width:300px;\n    height:200px;\n    border-radius: 8px;\n        /* Adds rounded corners */\n        margin-bottom: 1rem;\n        /* Adds space below the video */\n        object-fit: cover;\n        /* Ensures consistent video aspect ratio */\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n        /* Adds subtle shadow for depth */\n        border: 2px solid #ddd;\n}\n\n.review-card h5 {\n    text-align: center;\n    width: 80%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 700;\n    margin:10px;\n}\n\n.review-card p{\n    text-align: center;\n    width:80%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Poppins',sans-serif;\n    color:#666666;\n    margin:10px;\n}\n\n@media screen and (max-width:768px){\n    .reviews {\n            position: relative;\n            height: 120%;\n            margin-top: -0px;\n        }\n    .review-card {\n            display: flex;\n            flex-direction: column;\n            width: 70vw;\n            height: 100%;\n    \n            justify-content: center;\n            justify-items: center;\n            align-items: center;\n    \n    \n        }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
